<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { GtPushManager } from "@/utils/gtpush";

export default {
  name: "App",
  created() {
    new GtPushManager().init();
  },
};
</script>
